import { Injectable } from '@angular/core';
import { CaiApi } from '../../utils/cai-api';

import { API_CORE } from '../../constant/api-core.const';

@Injectable({
  providedIn: 'root',
})
export class SkyPalletService {
  async getExternalCalculate(
    skypalletId: string,
    token?: string,
  ): Promise<any> {
    const extraOptions = {
      queryParams: {} as any,
    };
    if (token) {
      extraOptions.queryParams.token = token;
    }
    const url = API_CORE.URLs.SkyPallet.SkyPalletById.replace(
      '{skypalletId}',
      skypalletId,
    );
    return CaiApi.get(API_CORE.name, url, extraOptions);
  }
}
